import type { Session } from '@supabase/supabase-js';
import { env } from '@/config/env';
import { supabase } from '@/lib/supabase/client';

export async function signInWithDiscord(): Promise<void> {
  if (!supabase) {
    return;
  }

  await supabase.auth.signInWithOAuth({
    provider: 'discord',
    options: {
      redirectTo: `${env.appUrl}/masses`,
    },
  });
}

export async function signOut(): Promise<void> {
  if (!supabase) {
    return;
  }

  await supabase.auth.signOut();
}

export async function getCurrentSession(): Promise<Session | null> {
  if (!supabase) {
    return null;
  }

  const { data } = await supabase.auth.getSession();
  return data.session;
}

